import { Palette } from 'config';
import styled from '@emotion/styled';

export const GoogleSelectedApp = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 20px;
  padding: 16px 50px 16px 16px;
  background: ${Palette.Primary._000};
  border: 1px solid #badefd;
  border-radius: 8px;
`;
export const DetailsHeader = styled.div`
  display: flex;
  justify-content: flex-start;
`;

export const ShowMoreLink = styled.span`
  color: ${Palette.Primary._500};
  cursor: pointer;
  margin-left: ${({ isOpen }) => isOpen && '3px'};
  white-space: nowrap;
  ::before {
    content: '...';
    color: ${Palette.PrimaryGray._500};
    display: ${({ isOpen }) => isOpen && 'none'};
    cursor: default;
    margin-right: 3px;
  }
`;
export const Desc = styled.span`
  font-size: 16px;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: ${Palette.PrimaryGray._900};
  margin-left: 10px;
`;
export const DetailsDescription = styled.div`
  margin: 8px 0;
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  display: flex;
  align-items: center;
  color: ${Palette.PrimaryGray._500};
  transition: all 1.3s linear;
`;
export const DetailsFooter = styled.div`
  display: flex;
`;
export const AppImage = styled.div`
  width: 88px;
  height: 88px;
  flex-shrink: 0;
  border-radius: 8px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
  }
`;

export const AppDetails = styled.div`
  width: 80%;
`;
export const DetailsPair = styled.div`
  display: flex;
  margin-right: 12px;
`;
export const DetailsKey = styled.div`
  margin-right: 4px;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  align-items: center;
  color: ${Palette.PrimaryGray._500};
  white-space: nowrap;
`;
export const DetailsValue = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: #000000;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: ${({ width }) => width};
`;

export const Label = styled.label`
  display: flex;
  align-items: center;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: ${Palette.PrimaryGray._700};
  padding-bottom: 10px;
  margin-top: 26px;
`;

export const Container = styled.div`
  padding: 0 24px;
`;

export const ExistingError = styled.span`
  margin-top: 8px;
  background: ${Palette.Red._000};
  color: ${Palette.Red._900};
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  padding: 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  svg {
    margin-right: 8px;
  }
`;
